import classNames from 'classnames';
import { DetailedHTMLProps, HTMLAttributes, SVGProps } from 'react';

import style from './Icon.module.css';

export type IconProps = DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>

export function Icon({
  ...props
}: IconProps) {
  const className = classNames(
    style.icon,
    // Base
    'inline-block -my-[0.15em] shrink-0 w-[1em] h-[1em] [&>svg]:w-full [&>svg]:h-full',
    props.className,
  );

  return (
    <span {...props} className={className} />
  );
}

export const Megaphone = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" strokeWidth="2" {...props}>
    <path d="M21 8.53C21.9374 9.46764 22.4639 10.7392 22.4639 12.065C22.4639 13.3908 21.9374 14.6624 21 15.6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17 5L12 9H8V15H12L17 19V5Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 15L6 20" stroke="currentColor" />
    <path d="M8 9H5C4.44772 9 4 9.44772 4 10V14C4 14.5523 4.44772 15 5 15H8" stroke="currentColor" />
  </svg>
);

export const Medal = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" strokeWidth="2" {...props}>
    <path d="M12 22C15.866 22 19 18.866 19 15C19 11.134 15.866 8 12 8C8.13401 8 5 11.134 5 15C5 18.866 8.13401 22 12 22Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 19C14.2091 19 16 17.2091 16 15C16 12.7909 14.2091 11 12 11C9.79086 11 8 12.7909 8 15C8 17.2091 9.79086 19 12 19Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.05432 9L5.03571 2H10.3939L12.4032 5.5L13.4078 7.25L13.9101 8.125L14.0357 8.34375" stroke="currentColor" />
    <path d="M15.2175 9L19.0357 2H13.9448L12.9903 3.75L12.513 4.625L12.2743 5.0625" stroke="currentColor" />
  </svg>
);

export const DonationBox = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" strokeWidth="2" {...props}>
    <path d="M21.43,11.48H2.57" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <line x1="17.24" y1="8.33" x2="6.76" y2="8.33" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.67,6.24h0c-1.16,0-2.1.94-2.1,2.1v12.57c0,1.16.94,2.1,2.1,2.1h14.67c1.16,0,2.1-.94,2.1-2.1v-12.57c0-1.16-.94-2.1-2.1-2.1h0" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.04,8.22l2.91-2.86c.24-.24.43-.52.56-.83.13-.31.2-.65.2-.98,0-.34-.07-.67-.2-.98-.13-.31-.32-.59-.57-.83-.49-.48-1.16-.75-1.84-.75-.69,0-1.35.27-1.84.75l-.26.26-.26-.26c-.49-.48-1.16-.75-1.85-.75-.69,0-1.35.27-1.84.75-.24.24-.43.52-.56.83s-.2.65-.2.98c0,.34.07.67.2.98.13.31.32.59.57.83l2.9,2.84" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
